var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, attrs: { id: "chatWindow" } },
    [
      _c("v-tour", {
        attrs: {
          callbacks: _vm.tourCallbacks,
          steps: _vm.steps,
          name: "chat-window-tour",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  _vm._l(tour.steps, function (step, index) {
                    return tour.currentStep === index
                      ? _c(
                          "v-step",
                          {
                            key: index,
                            attrs: {
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              labels: tour.labels,
                              "next-step": tour.nextStep,
                              "previous-step": tour.previousStep,
                              step: step,
                              stop: tour.stop,
                            },
                          },
                          [
                            _c("div", {
                              attrs: { slot: "actions" },
                              slot: "actions",
                            }),
                          ]
                        )
                      : _vm._e()
                  }),
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.activeConversation
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "pb-3",
                  attrs: {
                    lg:
                      _vm.layout &&
                      !_vm.observing.includes(_vm.activeConversation._id)
                        ? 6
                        : 8,
                    md: "8",
                  },
                },
                [
                  _c("div", { staticClass: "chatContainer" }, [
                    _c("div", { attrs: { id: "chatCloseSettingsButton" } }, [
                      _c("div", { staticClass: "user-meta" }, [
                        _vm.activeConversation.fullname
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "a-avatar",
                                    {
                                      key: _vm.activeConversation._id,
                                      staticStyle: {
                                        "background-color": "#3899ff",
                                        "border-radius": "7px !important",
                                      },
                                      attrs: {
                                        size: 24,
                                        src: _vm.getVisitorAvatarSrc(),
                                        shape: "square",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.activeConversation.fullname
                                              .substr(0, 1)
                                              .toLocaleUpperCase()
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                        },
                                      ],
                                      ref: "visitorNameInput",
                                      staticClass:
                                        "darkSpan ml-1 visitorName disableShortcut",
                                      class: {
                                        active: _vm.visitorNameInputActive,
                                      },
                                      attrs: {
                                        content:
                                          _vm.activeConversation.fullname,
                                        contentEditable: "true",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.setVisitorNameInputActive(
                                            false
                                          )
                                        },
                                        focus: function ($event) {
                                          return _vm.setVisitorNameInputActive(
                                            true
                                          )
                                        },
                                        focusUserInput: function ($event) {
                                          return _vm.focusVisitorNameInput()
                                        },
                                        keydown:
                                          _vm.handleVisitorNameInputKeyDown,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.capitalize(
                                            _vm.activeConversation.fullname
                                          )
                                        ) +
                                          "\n                                    "
                                      ),
                                      _c("ActionEdit", {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                              theme: _vm.isDarkMode
                                                ? "light-border"
                                                : "google",
                                            },
                                            expression:
                                              "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                          },
                                        ],
                                        staticClass: "mr-3",
                                        attrs: {
                                          content: _vm.$t(
                                            "message.clickToEdit"
                                          ),
                                          height: "11",
                                          width: "11",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ml-2 d-flex align-items-center",
                                      staticStyle: { color: "#3899ff" },
                                    },
                                    [
                                      _c("a-icon", {
                                        staticClass: "mr-2",
                                        attrs: { type: "mail" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                                theme: _vm.isDarkMode
                                                  ? "light-border"
                                                  : "google",
                                              },
                                              expression:
                                                "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                            },
                                          ],
                                          ref: "visitorEmailInput",
                                          staticClass:
                                            "visitorEmail disableShortcut",
                                          class: {
                                            active: _vm.visitorEmailInputActive,
                                          },
                                          attrs: {
                                            content:
                                              _vm.activeConversation.email,
                                            contentEditable: "true",
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.setVisitorEmailInputActive(
                                                false
                                              )
                                            },
                                            focus: function ($event) {
                                              return _vm.setVisitorEmailInputActive(
                                                true
                                              )
                                            },
                                            focusUserInput: function ($event) {
                                              return _vm.focusVisitorEmailInput()
                                            },
                                            keydown:
                                              _vm.handleVisitorEmailInputKeyDown,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.activeConversation.email ===
                                                  ""
                                                  ? _vm.$t("message.addEmail")
                                                  : _vm.activeConversation.email
                                              ) +
                                              "\n                                        "
                                          ),
                                          _c("ActionEdit", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                  theme: _vm.isDarkMode
                                                    ? "light-border"
                                                    : "google",
                                                },
                                                expression:
                                                  "{\n                                                followCursor: true,\n                                                placement: 'bottom-end',\n                                                theme: isDarkMode ? 'light-border' : 'google',\n                                            }",
                                              },
                                            ],
                                            staticClass: "mr-3",
                                            attrs: {
                                              content: _vm.$t(
                                                "message.clickToEdit"
                                              ),
                                              height: "11",
                                              width: "11",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c(
                                  "a-avatar",
                                  { attrs: { size: 24, shape: "square" } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm
                                            .getCustomLoginInputField(
                                              _vm.activeConversation
                                                .customLoginInfos,
                                              "fullname"
                                            )
                                            .substr(0, 1)
                                            .toLocaleUpperCase()
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "ellipsis" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getCustomLoginInputField(
                                        _vm.activeConversation.customLoginInfos,
                                        "fullname"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "<" +
                                      _vm._s(
                                        _vm.getCustomLoginInputField(
                                          _vm.activeConversation
                                            .customLoginInfos,
                                          "email"
                                        )
                                      ) +
                                      ">"
                                  ),
                                ]),
                              ],
                              1
                            ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row",
                          staticStyle: { "align-items": "center" },
                        },
                        [
                          !_vm.videoCallMode &&
                          !_vm.activeConversation.whatsappNumber
                            ? _c(
                                "a-popover",
                                {
                                  attrs: {
                                    id: "call-button",
                                    placement: "bottomRight",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _vm.user
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3 align-items-center naked-btn",
                                              attrs: {
                                                disabled: _vm.videoCallMode,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.call(false)
                                                },
                                              },
                                            },
                                            [
                                              _c("VideoCallSvg", {
                                                staticStyle: {
                                                  fill: "#3899ff",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-center pl-3 popoverFont cursorPointer",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Video Görüşmesi\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3 align-items-center naked-btn",
                                              attrs: {
                                                disabled: _vm.videoCallMode,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.call(true)
                                                },
                                              },
                                            },
                                            [
                                              _c("Call", {
                                                staticStyle: {
                                                  fill: "#3899ff",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-center pl-3 popoverFont cursorPointer",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Sesli Görüşme\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    { staticClass: "video-call-action-button" },
                                    [
                                      _c("VideoCallSvg", {
                                        staticStyle: { fill: "#3899ff" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "video-call-action-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelCall()
                                    },
                                  },
                                },
                                [
                                  _c("VideoCallCloseSvg", {
                                    staticStyle: { fill: "#f54e60" },
                                  }),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "a-popover",
                            {
                              attrs: {
                                id: "actionSettingsButton",
                                "data-v-step": "17",
                                placement: "bottomRight",
                                title: "",
                                trigger: "click",
                              },
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _vm.user
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-row" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-start",
                                            },
                                            [_c("block")],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.isRoot ||
                                          _vm.user.role.permissions
                                            .map(function (x) {
                                              return x.name
                                            })
                                            .includes("visitor.block")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.ban.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t("message.block_")
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-row mt-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-start",
                                            },
                                            [_c("private-message-icon")],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-end pl-3 popoverFont cursorPointer",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.pm.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.privateMessage_"
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.observing.includes(
                                        _vm.activeConversation._id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-start",
                                                },
                                                [_c("assign-representative")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.assign-agent",
                                                      modifiers: {
                                                        "assign-agent": true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.assignRep"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.observing.includes(
                                        _vm.activeConversation._id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-start",
                                                },
                                                [_c("open-chat")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.joinTheChat(
                                                        _vm.activeConversation
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.joinChat"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.observing.includes(
                                        _vm.activeConversation._id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-start",
                                                },
                                                [_c("forward-representative")],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-modal",
                                                      rawName:
                                                        "v-b-modal.forward-agent",
                                                      modifiers: {
                                                        "forward-agent": true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.forwardRep"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.activeConversation.users.filter(
                                        function (u) {
                                          return u !== null
                                        }
                                      ).length === 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-start",
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-danger",
                                                    attrs: {
                                                      icon: "sign-out-alt",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.leave.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.leaveChat"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm.activeConversation.users.filter(
                                            function (u) {
                                              return u !== null
                                            }
                                          ).length >= 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-row mt-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-start",
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-danger",
                                                    attrs: {
                                                      icon: "sign-out-alt",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "justify-content-end pl-3 popoverFont cursorPointer",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.end.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.endChat"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-row mt-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-start",
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "globe" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "justify-content-end pl-3 popoverFont cursorPointer",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.autoTranslate"
                                                    )
                                                  ) +
                                                  " :\n                                            "
                                              ),
                                              _c("a-switch", {
                                                staticClass: "ml-2 mr-2",
                                                attrs: { size: "small" },
                                                model: {
                                                  value: _vm.isSwitched,
                                                  callback: function ($$v) {
                                                    _vm.isSwitched = $$v
                                                  },
                                                  expression: "isSwitched",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                { staticClass: "video-call-action-button" },
                                [_c("chat-window-settings")],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "video-call-action-button",
                              attrs: { "data-v-step": "18" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.hide.apply(null, arguments)
                                },
                              },
                            },
                            [_c("minimize-window")],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.observing.includes(_vm.activeConversation._id) &&
                          _vm.activeConversation.status !== "destroyed"
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: _vm.isDarkMode
                                          ? "light-border"
                                          : "google",
                                      },
                                      expression:
                                        "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                    },
                                  ],
                                  staticClass: "video-call-action-button",
                                  attrs: {
                                    content:
                                      _vm.activeConversation.users.filter(
                                        function (u) {
                                          return u !== null
                                        }
                                      ).length === 1
                                        ? _vm.$t("message.endConversation")
                                        : _vm.$t("message.leaveChat"),
                                    "data-v-step": "19",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.closeButton.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_c("power-off")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.observing.includes(_vm.activeConversation._id) &&
                          _vm.activeConversation.status !== "destroyed"
                            ? _c(
                                "button",
                                {
                                  staticClass: "video-call-action-button",
                                  attrs: {
                                    disabled: !(
                                      _vm.activeConversation.status !==
                                      "destroyed"
                                    ),
                                    "data-v-step": "closeButton",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.leaveConversation(
                                        _vm.activeConversation._id
                                      )
                                    },
                                  },
                                },
                                [_c("circle-close-button")],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.autoTranslate.includes(_vm.activeConversation._id) &&
                    _vm.user.lang !==
                      _vm.activeConversation.visitor.preferredLang &&
                    !_vm.activeConversation.whatsappNumber
                      ? _c(
                          "div",
                          {
                            staticClass: "translate-detected",
                            on: {
                              click: function ($event) {
                                _vm.isSwitched = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("message.autoTranslateDetectedDesc", {
                                    visitorLanguage: !!_vm.languages.find(
                                      function (x) {
                                        return (
                                          x.code ===
                                          _vm.activeConversation.visitor
                                            .preferredLang
                                        )
                                      }
                                    )
                                      ? _vm.languages.find(function (x) {
                                          return (
                                            x.code ===
                                            _vm.activeConversation.visitor
                                              .preferredLang
                                          )
                                        }).originalName
                                      : _vm.activeConversation.visitor
                                          .preferredLang,
                                  })
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "messageList",
                        staticStyle: { position: "relative" },
                        style: {
                          height: _vm.observing.includes(
                            _vm.activeConversation._id
                          )
                            ? "calc(100% - 50px)"
                            : "calc(100% - 169px)",
                        },
                      },
                      [
                        _c("MessageList", {
                          attrs: {
                            "always-scroll-to-bottom": true,
                            colors: _vm.colors,
                            "is-colored": true,
                            ischatwindow: true,
                            messages: _vm.getMessages(),
                            participants: _vm.getParticipants(),
                            "scroll-top": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "message typing",
                        class: { live: _vm.typingMessage !== "" },
                      },
                      [
                        _vm.typingMessage !== ""
                          ? _c("div", { staticClass: "content p-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "text",
                                  staticStyle: { padding: "0 1rem" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "top-center",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'top-center',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "quote white-space-pre-line",
                                      attrs: { content: _vm.typingMessage },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.activeConversation.fullname
                                          ) +
                                          " " +
                                          _vm._s(_vm.$t("message.typing")) +
                                          ": " +
                                          _vm._s(_vm.typingMessage) +
                                          "...\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.observing.includes(_vm.activeConversation._id) &&
                    _vm.activeConversation.status !== "destroyed"
                      ? _c(
                          "form",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center bg-white",
                            staticStyle: {
                              position: "relative",
                              "margin-top": "auto",
                              height: "117px",
                              overflow: "hidden",
                            },
                            attrs: { id: "frmChat", autocomplete: "off" },
                            on: {
                              keydown: _vm.catchShortcut,
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.sendMessage.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "md-button",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "0",
                                  right: "74px",
                                  margin: "0",
                                  width: "24px",
                                  "min-width": "24px",
                                },
                                on: { click: _vm.selectFile },
                              },
                              [_c("md-icon", [_vm._v("attachment")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "0",
                                  right: "30px",
                                  margin: "0",
                                  width: "24px",
                                  "min-width": "24px",
                                },
                                attrs: {
                                  id: "send-message-button",
                                  tabindex: "1",
                                  type: "submit",
                                  variant: "none",
                                },
                              },
                              [_c("send-icon")],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.observing.includes(
                              _vm.activeConversation._id
                            ) && _vm.activeConversation.status !== "destroyed"
                              ? _c("VoiceRecorder", {
                                  attrs: { cb: _vm.sendVoiceMessage },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("ckeditor", {
                              key: "ckeditor-" + _vm.$i18n.locale,
                              ref: "ckeditor-" + _vm.activeConversation._id,
                              staticClass: "border-0 w-100",
                              attrs: {
                                id: "chat-editor",
                                config: _vm.editorConfig(),
                                editor: _vm.editor,
                                "tag-name": "textarea",
                              },
                              on: { ready: _vm.onEditorReady },
                              nativeOn: {
                                enter: function ($event) {
                                  return _vm.enter.apply(null, arguments)
                                },
                                keydown: function ($event) {
                                  return _vm.handleSubmit.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.messageModel,
                                callback: function ($$v) {
                                  _vm.messageModel = $$v
                                },
                                expression: "messageModel",
                              },
                            }),
                            _vm._v(" "),
                            _vm.waitingTabShortcut && _vm.suggestions.length > 0
                              ? _c(
                                  "div",
                                  {
                                    ref: "toolbarChat",
                                    attrs: { id: "suggestions", autofocus: "" },
                                    on: {
                                      blur: _vm.blurSCpanel,
                                      keydown: _vm.catchShortcut,
                                    },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      _vm._l(
                                        _vm.suggestions,
                                        function (subContent, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: subContent._id,
                                              staticClass: "pointer tab",
                                              class: {
                                                active:
                                                  index ===
                                                  _vm.suggestionsCurrent,
                                              },
                                              attrs: {
                                                "data-id": subContent._id,
                                                "data-letter":
                                                  subContent.letter,
                                                "data-number":
                                                  subContent.number,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onShortcutSelected(
                                                    subContent.languageContent[
                                                      _vm.$i18n.locale
                                                    ].content
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    subContent.languageContent[
                                                      _vm.$i18n.locale
                                                    ].name
                                                  ) +
                                                  "\n                                "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pointer-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(subContent.letter) +
                                                      "+" +
                                                      _vm._s(subContent.number)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass: "d-none",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    subContent.languageContent[
                                                      _vm.$i18n.locale
                                                    ].content
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.shortcutReminder
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center mt-1 shortcut-tippy",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#efa445" },
                            },
                            [_vm._v("lightbulb")]
                          ),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.shortcut.shortcutKey)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.shortcut[_vm.$i18n.locale])),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.layout && !_vm.observing.includes(_vm.activeConversation._id)
                ? _c(
                    "b-col",
                    {
                      staticClass: "pl-1.5 pb-3",
                      attrs: { "data-v-step": "20", lg: "3", md: "4" },
                    },
                    [
                      _c("DefaultContensWidget", {
                        attrs: { onShortcutSelected: _vm.onShortcutSelected },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "pl-1.5 pb-3",
                  attrs: {
                    lg:
                      _vm.layout &&
                      !_vm.observing.includes(_vm.activeConversation._id)
                        ? 3
                        : 4,
                    md: _vm.layout ? 6 : 4,
                    "data-v-step": "21",
                  },
                },
                [_c("UserInfoWidget")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isChatHistoryOpen ? _c("UserChatHistoryWidget") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }